module.exports = __webpack_public_path__ + "img/IconEntitiesInactive.eb5738c9.svg";